import { Injectable } from '@angular/core';

import { Redactor, RedactorApp, RedactorConfig } from '../../redactor.types';
import { RedactorPlugin } from '../interfaces';
import { RedactorExtension } from '../redactor-extension';

declare let $R: Redactor;
const LINK_TOGGLE_PLUGIN_TOKEN = 'rt-link-toggle';

/*
 * This plugin requires redactor module.link to work correctly
 */
export class LinkToggle implements RedactorPlugin {
  private app: any;
  private lang: any;
  private toolbar: any;

  public init(app: RedactorApp): void {
    this.app = app;
    this.lang = app.lang;
    this.toolbar = app.toolbar;
  }

  public start(): void {
    const currentLinkButton = this.toolbar.getButtons().find(({ name }: any) => name === 'link');

    if (!currentLinkButton) return;

    currentLinkButton.setApi(`plugin.${LINK_TOGGLE_PLUGIN_TOKEN}.toggleLink`);
  }

  // Link button callback
  public toggleLink(): void {
    this.app.api('module.link.open');
  }
}

@Injectable({ providedIn: 'root' })
export class RedactorLinkToggleExtension extends RedactorExtension {
  constructor() {
    super();

    $R.add('plugin', LINK_TOGGLE_PLUGIN_TOKEN, new LinkToggle());
  }

  public canInstall(config: RedactorConfig): boolean {
    return config.plugins!.includes(LINK_TOGGLE_PLUGIN_TOKEN);
  }

  public install(config: RedactorConfig): RedactorConfig {
    this.enable();

    return config;
  }
}
